import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * オプションサービス
 * 家財によらないオプションサービスマスタです。例: ジャストオンタイム、3区分時間帯指定
 */
export const yhc_options: ModelDef = {
  tableName: 'yhc_options',
  tableLabel: 'オプションサービス',
  tableComment:
    '家財によらないオプションサービスマスタです。例: ジャストオンタイム、3区分時間帯指定',
  primaryKeyColType: 'NUMBER',
  defaultSort: { key: 'createdAt', order: 'desc' },
  columns: {
    key: {
      type: 'STRING',
      label: '汎用キー',
      unique: true,
      editable: false,
      editableOnCreate: true,
      bulkEditable: false,
      validate: { notEmpty: true },
      inputHelpText: 'オプションの一意となるキー情報です',
    },
    price: {
      type: 'NUMBER',
      label: '金額',
      validate: { notEmpty: true },
    },
    admin_title: {
      type: 'STRING',
      label: '管理用名称',
      validate: { notEmpty: true },
    },
    description: {
      type: 'STRING',
      label: '説明文',
      replicable: true,
      width: { xs: 24 },
      inputHelpText: 'オプション選択上部に表示される説明文章です。',
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      validate: { notEmpty: true },
    },
    isEnabledOnDebug: {
      type: 'BOOLEAN',
      label: '開発プレビューで表示',
    },
    notice: {
      type: 'RICHTEXT',
      label: '注意事項',
      replicable: true,
      width: { xs: 48 },
      inputHelpText: 'オプション選択表示下部に表記される注意文言です。',
    },
  },
}
